module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAASUlEQVQoFZXBsREDQRDDMLL/omUGH3vnAHkkj+Sz8Ich8ln4wxA5LMQQOSzEEDksxBA5LMQQOSzEEDksxBA5LMQQOSzEEHkkj37f0ygPgcHEswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_07.png
// module id = 229
// module chunks = 0